// SEO metadata + structured data applied at runtime (single-page landing).
import { businessDetails, faqs } from "../data/content";

const TITLE = "Freeman Jones | IVA Customer Support and Online Services";
const DESC =
  "Access the Freeman Jones Customer App and Digital Postbox, find IVA support information, contact our team and view important arrangement documents.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function applySeo() {
  document.title = TITLE;
  document.documentElement.lang = "en-GB";

  setMeta("name", "description", DESC);
  setLink("canonical", window.location.origin + "/");

  setMeta("property", "og:title", TITLE);
  setMeta("property", "og:description", DESC);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:locale", "en_GB");
  setMeta("property", "og:url", window.location.origin + "/");
  setMeta("name", "twitter:card", "summary_large_image");

  const ld = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": ["Organization", "ProfessionalService"],
        name: "Freeman Jones Ltd",
        url: window.location.origin + "/",
        telephone: businessDetails.phoneDisplay,
        email: businessDetails.email,
        address: {
          "@type": "PostalAddress",
          streetAddress: "Blue Tower, MediaCityUK",
          addressLocality: "Salford Quays",
          postalCode: "M50 2NT",
          addressCountry: "GB",
        },
        contactPoint: {
          "@type": "ContactPoint",
          telephone: businessDetails.phoneDisplay,
          contactType: "customer support",
          areaServed: "GB",
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  let script = document.getElementById("fj-jsonld");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "fj-jsonld";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(ld);
}

// Lightweight metadata for standalone legal pages (no landing JSON-LD).
export function applyPageSeo({ title, description, path }) {
  document.title = title;
  setMeta("name", "description", description);
  setLink("canonical", window.location.origin + path);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", window.location.origin + path);

  const ld = document.getElementById("fj-jsonld");
  if (ld) ld.remove();
}
